var _path, _path2, _ellipse, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcMegaphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 429,
    height: 300,
    viewBox: "0 0 429 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 3L137 72M79.5 81L117 99M3 131.5C44.0051 131.5 66.9949 131.5 108 131.5M76 185.5L117 173M31.5 260L137 202",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M269 135C269 158.131 263.81 178.948 255.546 193.894C247.234 208.927 236.152 217.5 224.5 217.5C212.848 217.5 201.766 208.927 193.454 193.894C185.19 178.948 180 158.131 180 135C180 111.869 185.19 91.0516 193.454 76.1057C201.766 61.0725 212.848 52.5 224.5 52.5C236.152 52.5 247.234 61.0725 255.546 76.1057C263.81 91.0516 269 111.869 269 135Z",
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.5,
    cy: 135,
    rx: 8,
    ry: 15,
    fill: "#BAC3D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M407.5 150C410.7 140.4 408.833 126.333 407.5 120.5L423 126C429.4 133.6 425.667 141.167 423 144L407.5 150Z",
    fill: "#BAC3D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M423 126L225 52M238 213.5L423 144",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M220 123L266 108.5M220 147L266 163.5",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M342 272.5C330.5 275.5 321.5 271 320 268.5C319.56 271.694 317.638 282.082 319.5 289C320.456 292.552 323.286 294.822 326 295.5C328.738 296.185 332.678 295.486 335 292.5C339.463 286.761 341.452 275.789 342 272.5Z",
    fill: "#BAC3D7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M329 180L319.5 271C318.788 281.5 315 293 325 296C337.21 299.663 338.5 288.5 341 277L351.5 222L361.5 167.5",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M423 126C425.5 128.833 429 136.4 423 144",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M406.5 120C408.333 125.833 410 139 406.5 150",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcMegaphone);
export default __webpack_public_path__ + "static/media/oc-megaphone.9ab3ac66a49c5c45a65ef021f3dbb209.svg";
export { ForwardRef as ReactComponent };